/**
 * @Author: alexandre
 * @Date:   2018-03-07T11:33:46-05:00
 * @Email:  alexandre@atomicmotion.com
 * @Filename: App.js
 * @Last modified by:   alexandre
 * @Last modified time: 2018-09-05T09:10:10-04:00
 * @Copyright: Atomic Motion
 */

import React, {
  Component
} from 'react';
import axios from 'axios';
import 'babel-polyfill';
import ReactTable from 'react-table'
import queryString from 'query-string';
import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

// import {
//   Redirect,
//   BrowserRouter as Router,
//   Link
// } from "react-router-dom";


class MyTrComponent extends React.Component {
  constructor() {
    super()
    this.state = {
      background: null
    }
  }
  render() {
    const {
      children,
      className,
      style,
      ...rest
    } = this.props
    return (
      <div
				className={'rt-tr ' + className}
				style={{
					...style,
					...this.state
				}}
				{...rest}
				onMouseEnter={() => this.setState({
					//background: 'rgba(219, 241, 255, 0.2)',
          background: 'rgba(199, 32, 52, 0.1)',
          cursor: 'pointer',
				})}
				onMouseLeave={() => this.setState({
					background: null
				})}
			>
				{children}
			</div>
    )
  }
}

class App extends Component {

  constructor(props) {
    super(props);


    this.state = {
      ncpldata: this.props.ncpldata,
      carriers: [],
      currentCarrier: "",
      fadein: false,
      //currentCarrier: null,
    };
  }

  componentWillUnmount = () => {
    
    
  } 
  componentDidMount = () => {
    scroll.scrollTo(
      this.props.scrollPos,
      {
        duration: 0,
        smooth: true,
      });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ncpldata: nextProps.ncpldata });
    
  }


  componentWillMount = () => {


    
    

    const parsed = queryString.parse(window.location.search);

    if (parsed.bin) {
      this.setState({
        currentCarrier: parsed.bin
      })
    } else {
      this.setState({
        currentCarrier: null
      })
    }

  }



  flattenCarriers = (ncpldata) => {

    let returnData = [];

    for (let i = 0; i < ncpldata.length; i++) {

      returnData[i] = {
        name: this.props.lang == "en" ? ncpldata[i].name.en : ncpldata[i].name.fr,
        id: ncpldata[i].bin,
        versionOne: ncpldata[i].versions[0],
        versionTwo: ncpldata[i].versions[1],
        age_days: ncpldata[i].age_days,
        claim_01: ncpldata[i].claim_01 === "Y" ? <span>{this.props.lang == "en" ? "Claim" : 'Demande de prestations' }</span> : null,
        reversal_02: ncpldata[i].reversal_02 === "Y" ? <span>{this.props.lang == "en" ? "Claim Reversals" : "Annulation d’une demande de prestations" }</span> : null,
        predetermination_03: ncpldata[i].predetermination_03 === "Y" ? <span>{this.props.lang == "en" ? "Predetermination" : "Plan de traitement"}</span> : null,
        outstanding_04: ncpldata[i].outstanding_04 === "Y" ? <span>{this.props.lang == "en" ? "Request for Outstanding Transaction" : "Demande relative aux transactions en suspens"}</span> : null,
        summary_reconcilation_05: ncpldata[i].summary_reconcilation_05 === "Y" ? <span>{this.props.lang == "en" ? "Summary Reconciliation" : "Rapprochement sommaire"}</span> : null,
        payment_reconciliation_06: ncpldata[i].payment_reconciliation_06 === "Y" ? <span>{this.props.lang == "en" ? "Payment Reconciliation" : "Demande de rapprochement des paiements"}</span> : null,
        cob_07: ncpldata[i].cob_07 !== "N" ? <span>{this.props.lang == "en" ? "Coordination of Benefit (COB) Transaction" : "Transactions pour la coordination des prestations"}</span> : null,
        eligibility_08: ncpldata[i].eligibility_08 === "Y" ? <span>{this.props.lang == "en" ? "Eligibility" : "Vérification d’admissibilité" }</span> : null,
        attachment_09: ncpldata[i].attachment_09 === "Y" ? <span>{this.props.lang == "en" ? "Attachment" : "Pièce jointe"}</span> : null,
      }
    }
    return returnData
  }

  render() {


    var columns = [{
        id: 'name',
        accessor: data => <p>{data.name}</p>,
        Header: <div><p>{this.props.lang == "en" ? 'Carrier Name' : 'Nom de l’assureur'}</p></div>,
        resizable: false,
        width: 165,
      },
      {
        accessor: 'id',
        Header: <div><p>{this.props.lang == "en" ? (<span>Carrier ID</span>) : (<span>Numéro<br/>d'identification (ID)</span>)}</p></div>,
        resizable: false,
        width: 150,
        style: {
          textAllign: "center",
        },
      },
      {
        id: 'version',
        accessor: data => <span>{data.versionOne}{data.versionTwo ? ", " + data.versionTwo : ""}</span>,
        Header: 'Version',
        sortable: false,
        resizable: false,
        width: 80,
        style: {
          'text-allign': "center",
        },
      },
      {
        accessor: 'age_days',
        Header: <div>{this.props.lang == "en" ? (<span>Age Limit (Days)</span>) : (<span>Délai alloué pour<br/>la soumission (jours)</span>)}</div>,
        sortable: false,
        resizable: false,
        width: 150,
      },
      {
        id: 'transaction',
        accessor: data => {
          return (
            <span>
              {data.claim_01 ? <p>{data.claim_01}</p> : ""}
              {data.reversal_02 ? <p>{data.reversal_02}</p> : ""}
              {data.predetermination_03 ? <p>{data.predetermination_03}</p> : ""}
              {data.outstanding_04 ? <p>{data.outstanding_04}</p> : ""}
              {data.summary_reconcilation_05 ? <p>{data.summary_reconcilation_05}</p> : ""}
              {data.payment_reconciliation_06 ? <p>{data.payment_reconciliation_06}</p> : ""}
              {data.cob_07 ? <p>{data.cob_07}</p> : ""}
              {data.eligibility_08 ? <p>{data.eligibility_08}</p> : ""}
              {data.attachment_09 ? <p>{data.attachment_09}</p> : ""}
            </span>
          )
        },
      Header: <div>{this.props.lang == "en" ? (<span>Supported Transaction <br/>Types</span>) : (<span>Transactions acceptées</span>) }</div>,
        sortable: false,
        resizable: false,
      },
    ];

    return (
      <div className={this.state.fadein === true? "App fadeOut" : "App"}>

        <div className="body-copy">
          {this.props.lang == "en" ? (
            <p>The following list of carriers accept CDAnet dental benefit claims. Click on selected carrier to view detailed carrier information, including a complete list of supported transactions, coordination of benefits claim processing instructions and if available, the carrier mailing information. Information on carrier updates is available at <a href="http://www.cda-adc.ca/en/services/cdanet/cdanetnews/default.asp">News</a>.</p>
          ) : (
          this.props.lang == "fr" &&
            <p>Les assureurs de la liste ci-dessous acceptent les demandes d’indemnisation par CDAnet. Cliquez sur l’assureur voulu pour voir toutes les informations qui le concernent, y compris la liste de toutes les transactions qu’il accepte, les instructions pour la coordination des prestations et, le cas échéant, son adresse postale. Les changements concernant un assureur paraîtront dans le <a href="http://www.cda-adc.ca/fr/services/cdanet/cdanetnews/default.asp"> bulletin de nouvelles.</a></p>
          )}
        </div>
        <ReactTable
           data={this.flattenCarriers(this.state.ncpldata)}
           columns={columns}
           showPaginationBottom={false}
           defaultPageSize={1000}
           minRows={0}
           TrComponent={MyTrComponent}

           getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                this.props.setScrollPos(window.scrollY);
                scroll.scrollTo(
                  document.getElementById("root").offsetTop - 20,
                  {
                    duration: 0,
                    smooth: true,
                  });

                // setTimeout(() => {
                //   this.props.history.push("/bin/" + rowInfo.original.id)
                // }, 500)

                this.props.history.push("/bin/" + rowInfo.original.id)

                //history.push("/bin/" + rowInfo.original.id)
                // this.setState({
                //    currentCarrier: rowInfo.original.id,
                //    fadein: false,
                // })
                //return ( <Redirect to={"/bin/" +this.state.currentCarrier} push={true} /> )
              }
            }
          }}
         />
      </div>
    );
  }
}

export default App;